import { Navbar as NavBarComponent } from '@/common/ui/Navbar'
import { Dropdown } from '@/common/ui/Dropdown'
import { NavbarProfileDropdownMenu, NavbarMenuModals } from '@/app/entities/profileMenu/ui/ProfileMenu'
import { useCurrentOrg } from '@/app/entities/org/model'
import { BalanceButton } from './BalanceButton'
import { useMe } from '@/common/entities/me/model/me'
import { Button } from '@/common/ui/Form/Button'
import { Avatar } from '@/common/ui/Avatar'
import { OrgPickerList } from '@/app/entities/org/ui/SelectOrg'
import { NavLink, useNavigate } from 'react-router-dom'
import { cn } from '@/common/lib/cn/cn'
import { ROUTES } from '@/app/app/routing/routes'
import { Menu, MenuItem } from '@/common/ui/Menu'

const navItems = [
    { to: '/app/products', label: 'Работа с товарами' },
    { to: ROUTES.STATS, label: 'Статистика' },
] as const

const getNavLinkClass = ({ isActive }: { isActive: boolean }) =>
    cn(
        'px-3 py-2 text-sm font-medium rounded-field transition-colors',
        isActive ? 'bg-base-200 text-base-content' : 'text-base-content/70 hover:text-base-content hover:bg-base-200/60'
    )

export const NavbarMobileMenu = () => {
    return (
        <Menu className='flex w-full flex-col flex-nowrap p-0'>
            {navItems.map(item => (
                <MenuItem key={item.to}>
                    <NavLink to={item.to} className={({ isActive }) => (isActive ? 'menu-active' : '')}>
                        {item.label}
                    </NavLink>
                </MenuItem>
            ))}
        </Menu>
    )
}

export const Navbar = () => {
    const { data: currentOrg } = useCurrentOrg()
    const { me } = useMe()
    const navigate = useNavigate()
    const handleAfterSelect = () => {
        setTimeout(() => navigate('/app/products', { replace: true }), 0)
    }

    return (
        <NavBarComponent drawerId='my-drawer-1' className='sticky top-0 z-50'>
            <nav className='ml-4 hidden items-center gap-1 lg:flex' aria-label='Основная навигация'>
                {navItems.map(item => (
                    <NavLink
                        key={item.to}
                        to={item.to}
                        className={getNavLinkClass}
                        aria-label={item.label}
                        tabIndex={0}
                    >
                        {item.label}
                    </NavLink>
                ))}
            </nav>
            <div className='flex items-center gap-2'>
                <BalanceButton />
                <NavbarMenuModals />
                <div className='navbar-avatar-split flex min-w-0 items-center rounded-full'>
                    <Dropdown className='dropdown-end hidden md:block'>
                        <Button
                            as='summary'
                            variant='ghost'
                            size='lg'
                            className=''
                            title='Сменить организацию'
                            aria-label='Сменить организацию'
                        >
                            <div className='navbar-avatar-text min-w-0 max-w-[12rem]'>
                                <span className='truncate'>{currentOrg?.name}</span>
                            </div>
                        </Button>
                        <div className='dropdown-content shadow-sm flex w-[300px] max-w-[300px] flex-col gap-3 p-4'>
                            <h3 className='text-lg font-bold'>Выбор организации</h3>
                            <OrgPickerList menuClassName='!p-0' afterSelect={handleAfterSelect} />
                            <Button
                                as='label'
                                htmlFor='addOrgModal'
                                emphasis='secondary'
                                variant='ghost'
                                size='lg'
                                className='w-full shrink-0'
                                data-close-dropdown
                            >
                                Добавить организацию
                            </Button>
                        </div>
                    </Dropdown>
                    <Dropdown className='dropdown-end'>
                        <Button
                            as='summary'
                            variant='ghost'
                            size='lg'
                            className='btn-icon-only rounded-full rounded-l-none border-0 pl-1.5 pr-2.5'
                            title='Меню профиля'
                            aria-label='Открыть меню профиля'
                        >
                            <Avatar size='sm' placeholder={currentOrg?.name} image={me?.avatar_url ?? undefined} />
                        </Button>
                        <NavbarProfileDropdownMenu />
                    </Dropdown>
                </div>
            </div>
        </NavBarComponent>
    )
}
